<template>
  <div>
    <div v-if="!showPlan">
      <div class="flex sidebar-topfixpart bg-primary p-4">
        <feather-icon
          icon="ChevronLeftIcon"
          @click="handleBack"
          class="cursor-pointer text-white"
          svgClasses="w-6"
        ></feather-icon>
        <h2 class="h2-class font-semibold text-white pl-4">ADD {{ title }}</h2>
      </div>

      <div class="p-4">
        <FileUploader
          :accept="type"
          :onSuccess="loadImage"
          v-if="!selectedImage"
        />
        <Cropper
          class="cropper"
          :src="renderedImage"
          v-if="selectedImage && currentPage === 'Image Post'"
          @change="chnage"
          ref="cropper"
          :default-size="defaultSize"
        />
        <video
          controls
          v-show="selectedImage && currentPage === 'Video Post'"
          :src="renderedImage"
        ></video>
        <audio
          controls
          v-show="selectedImage && currentPage === 'Podcast'"
          :src="renderedImage"
        ></audio>
        <b-textarea
          placeholder="Caption"
          class="form-control-muted mb-4 mt-4"
          v-model="text"
        />
        <base-button
          block
          type="primary"
          :disabled="!!!renderedImage"
          class="rounded-none RadiusBtn font-semibold mt-8"
          @click="handleChooseChannel"
          >CHOOSE CHANNEL</base-button
        >
      </div>
      <footer
        class="footer-fix bottom-0 md:fixed lg:fixed md:w-1/4 lg:w-1/4 w-full"
      ></footer>
    </div>
  </div>
</template>
<script>
import FileUploader from "@/components/FileUploader.vue";
import { mapState } from "vuex";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    FileUploader,
    Cropper,
  },
  data() {
    return {
      showPlan: false,
      selectedImage: null,
      renderedImage: null,
      text: "",
      cropperImg: "",
    };
  },
  watch: {
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "text", value: val });
    },
    selectedImage(val) {
      this.$store.commit("posts/SET_POST", { key: "media", value: val });
    },
  },
  computed: {
    ...mapState("posts", {
      currentPage: "currentPage",
      type: "type",
    }),
    title() {
      return this.type.toUpperCase();
    },
  },
  methods: {
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    handleBack() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "home");
    },
    handleChooseChannel() {
      if (this.text.trim() == "") {
        this.$swal({
          text: "Caption is required!",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      this.$store.commit("posts/SET_CURRENT_PAGE", "Choose Channel");
    },
    loadImage(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.selectedImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    chnage(img) {
      // console.log(img);
      this.cropperImg = img;
      this.selectedImage = this.dataURLtoFile(
        img.canvas.toDataURL(),
        "image.png"
      );
    },
  },
};
</script>

<style>
.imagebg {
  background: rgba(0, 0, 0, 0.5);
}
</style>
